import {CREDITS} from '../../../constants/credits'
import React from 'react'
import {NumericFormat} from 'react-number-format'
import './RemainingBudget.scss'
import {useCurrentGuildContext} from '../../../util/routing'
import {useGetGuildQuery} from '../../rtkGuildApi'
import {BodyMedium} from '../../../genericComponents/typographie/UIKitV2/BodyMedium'

const RemainingBudget = () => {
    const [currentGuildContext] = useCurrentGuildContext()
    const {data: guild} = useGetGuildQuery(currentGuildContext?.guildId, {skip: !currentGuildContext?.guildId || !currentGuildContext?.guildAdmin})

    return (
        <BodyMedium title={'Remaining Budget:'} className={'remaining-budget-label'}>
            <NumericFormat
                data-testid="test-remaining-budget-value"
                value={guild?.budget}
                displayType={'text'}
                thousandSeparator={' '}
                decimalSeparator="."
                suffix={` ${CREDITS}`}
                className="remaining-budget-value"

            />
        </BodyMedium>
    )
}

export default RemainingBudget